/* eslint-disable react/display-name */
import React, { useEffect, useRef, useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import { RootState } from 'Store'
import { Col, Dropdown, Image, Row, Space } from 'antd'
import { formatDateTime, getMenuTypeName, getReturnOrderStatus, numberWithComma } from 'helpers/format'
import { selectCurrentUser } from 'Store/user/selector'
import LoadingView from 'Components/modal/LoadingView'
import { DetailDrawer } from 'Components/common/MainLayout'
import styled from 'styled-components'
import { MyTheme } from 'Components/common/Theme'
import ReturnOrderPDF from './components/ReturnOrderPDF'
import { PrimaryButton } from 'Components/button'
import { CheckOutlined, PrinterOutlined } from '@ant-design/icons'
import { TableListPage } from 'Components/common/Table'
import { InfoItem } from 'Pages/Orders/components'
import SupplierOrderDetail from '../SupplierInvoice/detail'
import { getReturnDetailAPI, updateReturnStatusAPI } from 'Store/return-order/api'
import { ReturnDetailReq, ReturnProduct, UpdateReturnReq } from 'Store/return-order/types'
import {
  selectReturnActionEvent,
  selectReturnDetail,
  selectReturnDetailEvent,
} from 'Store/return-order/selector'
import { appConfig } from 'config'
import { ImageFallback, menuReturnPaymentTypes, ReturnStatus, ReturnStatusText } from 'helpers/constanst'
import { MenuPrints, MultiUploadForm } from 'Components/form'
import { StatusTag } from 'Components/utilities'
import { ConfirmDailog, EventModal } from 'Components/modal'
import { clearEventAction } from 'Store/return-order/actions'
import ProductUomSystemInfo from 'Pages/Product/components/ProductUomSystemInfo'

type Props = ReduxProps & {
  visible: boolean
  onCloseDrawer: () => void
  onSuccess?: () => void
  onPaymentSuccess?: () => void
  id?: number
}

const ReturnDetail: React.FunctionComponent<Props> = props => {
  const {
    onCloseDrawer,
    visible,
    currentUser,
    id = 0,
    detail,
    detailEvent,
    event,
    onSuccess = () => {},
  } = props
  const [detailDrawer, setDetailDrawer] = useState(false)
  const [selectedID, setSelectedID] = useState(0)
  const [statusUpdating, setStatusUpdating] = useState('' as ReturnStatus)
  const [confirmDialog, setConfirmDialog] = useState(false)

  console.log('detail', detail)

  const dispatch = useDispatch()
  const billingNotesePDF = useRef(null as any)
  const billingNoteseLitePDF = useRef(null as any)

  useEffect(() => {
    if (visible) {
      onGetDetail()
    }
  }, [visible, id])

  const onGetDetail = (): void => {
    const req: ReturnDetailReq = {
      id,
    }
    dispatch(getReturnDetailAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.id || ''))
  }

  const onUpdateStatus = (status: ReturnStatus): void => {
    const req: UpdateReturnReq = {
      id,
      status: status,
    }
    dispatch(updateReturnStatusAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.id || ''))
  }

  const onOpenDetailDrawer = () => {
    setDetailDrawer(true)
  }

  const onCloseDetailDrawer = () => {
    setDetailDrawer(false)
  }

  const renderInfo = (title: string, value: any, span: number = 15) => {
    return <InfoItem title={title} value={value} span={span} />
  }

  const SupplierOrdeDetailDrawer = (
    <SupplierOrderDetail
      id={selectedID}
      visible={detailDrawer}
      onCloseDrawer={onCloseDetailDrawer}
      onSuccess={() => {}}
      viewMode={false}
    />
  )

  const renderImage = (product_option: string) => (
    <ThumbImage src={appConfig.assetCdnEndpoint + product_option} fallback={ImageFallback} />
  )

  const renderProductName = (title: string, record: ReturnProduct) => {
    const isSameTitle = title == record.product_option_title
    return (
      <>
        <RowTile>{title}</RowTile>
        {!isSameTitle && <ProductDesc>{record.product_option_title}</ProductDesc>}
      </>
    )
  }

  const ConfirmApproveDailog = (
    <ConfirmDailog
      title={`ยืนยันการเปลี่ยนสถานะ`}
      description={`ยืนยันเปลี่ยนสถานะเป็น "${getReturnOrderStatus(statusUpdating).text}" หรือไม่?`}
      confirmBtnTxt="ยืนยัน"
      isShow={confirmDialog}
      handleOk={() => onUpdateStatus(statusUpdating)}
      handleCancel={() => setConfirmDialog(false)}
      loading={event.IsLoading}
    />
  )

  const onClickUpdateStatus = (status: ReturnStatus): void => {
    setStatusUpdating(status)
    setConfirmDialog(true)
  }

  const renderFooterContent = () => {
    const btn = [] as any[]
    if (detail?.status === ReturnStatus.DRAFT) {
      btn.push(
        <PrimaryButton
          btnType="Primary"
          text={`${ReturnStatusText.PENDING}`}
          onClick={() => {
            onClickUpdateStatus(ReturnStatus.PENDING)
          }}
          //icon={<CheckOutlined />}
        />,
      )
    }
    if (detail?.status === ReturnStatus.PENDING) {
      btn.push(
        <PrimaryButton
          btnType="Primary"
          text={ReturnStatusText.SUCCESS}
          onClick={() => {
            onClickUpdateStatus(ReturnStatus.SUCCESS)
          }}
          //icon={<CheckOutlined />}
        />,
      )
    }

    return (
      <Space size="middle" align="baseline">
        <PrimaryButton btnType="Cancel" text="ปิด" onClick={onCloseDrawer} />
        {btn}
      </Space>
    )
  }

  const renderQuantity = (quantity: number, record: ReturnProduct) => {
    const uom = (
      <ProductUomSystemInfo
        multiplier={record.multiplier}
        quantity={record.quantity}
        uom={record.product_uom || ''}
        quantitySystem={record.quantity_system || 0}
        uomSystem={record.product_uom_system || ''}
        showQuantity={true}
      />
    )
    return (
      <Space>
        {numberWithComma(quantity)}
        {uom}
      </Space>
    )
  }

  const columns = [
    {
      title: 'รูปภาพ',
      dataIndex: 'picture',
      key: 'picture',
      render: renderImage,
    },
    {
      title: 'รหัสสินค้า',
      dataIndex: 'code',
      key: 'code',
    },
    {
      title: 'รายการ',
      dataIndex: 'title',
      key: 'title',
      render: renderProductName,
      //width: '150px',
    },
    {
      title: 'ยี่ห้อ',
      dataIndex: 'brand',
      key: 'brand',
    },
    {
      title: 'จำนวน(ซื้อ)',
      dataIndex: 'quantity',
      key: 'quantity',
      width: '120px',
      render: renderQuantity,
    },
    // {
    //   title: 'หน่วย',
    //   dataIndex: 'unit',
    //   key: 'unit',
    // },
    {
      title: 'ราคา/หน่วย',
      dataIndex: 'price',
      key: 'price',
      render: (price: number) => numberWithComma(price, true),
      align: 'right',
    },
    {
      title: 'ราคารวม',
      dataIndex: 'total_price',
      key: 'total_price',
      render: (price: number) => numberWithComma(price, true),
      width: '100px',
      align: 'right',
    },
    {
      title: '',
      dataIndex: '',
      key: '',
      width: '50px',
    },
    {
      title: <Bold>จำนวน(คืน)</Bold>,
      dataIndex: 'return_qty',
      key: 'return_qty',
      width: '100px',
      render: (val: number, record: ReturnProduct) => (
        <Bold>
          {numberWithComma(val)} {record.return_product_uom}
        </Bold>
      ),
    },
    {
      title: <Bold>ยอดเงินคืน</Bold>,
      dataIndex: 'return_amount',
      key: 'return_amount',
      //render: (price: number) => numberWithComma(price, true),
      render: (val: number, record: ReturnProduct) => <Bold>{numberWithComma(val, true)}</Bold>,
    },
  ]

  const renderTitle = () => {
    return (
      <Row justify="start" gutter={[8, 8]} align="top">
        <Col>
          <Space direction="vertical" size="small">
            <Space size="small" wrap={true}>
              {`เลขที่คำสั่งซื่อ : ${detail?.order_no}`}
            </Space>
            <Space size="small" wrap={true}>
              <SmallText>วันที่รับคืนสินค้า : {formatDateTime(detail?.created_at || '')}</SmallText>
            </Space>
          </Space>
        </Col>
      </Row>
    )
  }

  const renderStatus = (status: string) => {
    const statusResult = getReturnOrderStatus(status)
    return <StatusTag text={statusResult.text} color={statusResult.color} />
  }

  const clearEvent = (): void => {
    dispatch(clearEventAction())
  }

  const onEventSuccess = (): void => {
    setConfirmDialog(false)
    clearEvent()
    onSuccess()
    onGetDetail()
  }

  return (
    <DetailDrawer
      title={renderTitle()}
      onCloseDrawer={onCloseDrawer}
      visible={visible}
      footer={renderFooterContent()}
      width={'90%'}
      maskClosable={true}
    >
      <LoadingView isShow={detailEvent.IsLoading} />
      <EventModal event={[event]} enable={true} successCalback={onEventSuccess} errorCalback={clearEvent} />
      <Row justify="space-between" gutter={[16, 8]}>
        <Col md={24} xs={24}>
          <BoxWrapper>
            <Row justify="space-between" gutter={[16, 8]}>
              <Col md={24} xs={24}>
                <BoxTitle>รายละเอียดคำสั่งซื้อ</BoxTitle>
              </Col>
              <Col md={12} xs={24}>
                {renderInfo('เลขที่คำสั่งซื้อ', detail?.order_no)}
                {renderInfo('ลูกค้า', detail?.customer_fullname)}
              </Col>
            </Row>
          </BoxWrapper>
        </Col>

        <Col md={24} xs={24}>
          <BoxWrapper>
            <Row justify="space-between" gutter={[16, 8]}>
              <Col>
                <BoxTitle>รายการคืนสืนค้า</BoxTitle>
              </Col>
              <Col>
                <Dropdown
                  key="more"
                  overlay={
                    <MenuPrints
                      nomalPrintRef={billingNotesePDF}
                      litePrintRef={billingNoteseLitePDF}
                      title={`ใบรับคืนสินค้า-${detail?.order_no}`}
                    />
                  }
                  trigger={['click', 'hover']}
                >
                  <PrimaryButton
                    btnType="Primary"
                    text="พิมพ์ใบรับคืนสินค้า/ใบลดหนี้"
                    icon={<PrinterOutlined />}
                    onClick={() => {}}
                    size="middle"
                  />
                </Dropdown>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <TableListPage
                  columns={columns}
                  datas={detail?.products || []}
                  isLoading={false}
                  paginationContent={null}
                  size="small"
                  scrollX={800}
                />
              </Col>
              <Col span={24}>
                <Row justify="end" align="middle" gutter={[32, 8]}>
                  <Col>
                    <Space>
                      ยอดเงินคืนสุทธิ
                      <Price> {numberWithComma(detail?.total_amount || 0, true)}</Price> บาท
                    </Space>
                  </Col>
                </Row>
              </Col>
            </Row>
          </BoxWrapper>
        </Col>
        <Col md={24} xs={24}>
          <BoxWrapper>
            <Row justify="space-between" gutter={[16, 8]}>
              <Col md={24} xs={24}>
                <BoxTitle>รายละเอียดการคืน</BoxTitle>
              </Col>
              <Col md={12} xs={24}>
                {renderInfo('วันที่รับคืนสินค้า', formatDateTime(detail?.created_at || ''))}
                {renderInfo('เหตุผลการคืน', detail?.reason)}
                {renderInfo('รับคืนโดย', detail?.officer)}
                {renderInfo(
                  'ช่องทางการรับเงินคืน',
                  getMenuTypeName(menuReturnPaymentTypes, detail?.return_type || ''),
                )}
                {renderInfo('หมายเหตุ', detail?.remark)}
                {renderInfo('หลักฐาน/รูปภาพ/เอกสาร', detail?.docs && detail?.docs.length > 0 ? ' ' : '')}
                <MultiUploadForm
                  token={''}
                  onUpdateData={() => {}}
                  files={detail?.docs || []}
                  folder=""
                  listType="text"
                  isPrivate={true}
                  name="docs"
                  description=""
                  isRequired={false}
                  isError={false}
                  label=""
                  readOnly={true}
                />
              </Col>
              <Col md={12} xs={24}>
                {renderInfo('สถานะการคืนเงิน', renderStatus(detail?.status || ''))}
                {detail?.status === ReturnStatus.SUCCESS &&
                  renderInfo('วันที่คืนเงินสำเร็จ', formatDateTime(detail?.updated_at || ''))}
              </Col>
            </Row>
          </BoxWrapper>
        </Col>
      </Row>
      {SupplierOrdeDetailDrawer}
      {ConfirmApproveDailog}
      <Row ref={billingNotesePDF}>
        <Col span={24}>
          <ReturnOrderPDF detail={detail} currentUser={currentUser} />
        </Col>
      </Row>
      <Row ref={billingNoteseLitePDF}>
        <Col span={24}>
          <ReturnOrderPDF detail={detail} currentUser={currentUser} isLite={true} />
        </Col>
      </Row>
    </DetailDrawer>
  )
}

const SmallText = styled.div`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
`

const BoxTitle = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body3};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.primary};
`

const BoxWrapper = styled.div`
  width: 100%;
  border-radius: 10px;
  padding: 15px 10px;
  //border: 1px solid ${(props: { theme: MyTheme }): string => props.theme.colors.whitebg};
  border: 1px solid #f0f0f0;
  margin-bottom: 10px;
  background-color:  ${(props: { theme: MyTheme }): string => props.theme.colors.white};
`

const Price = styled.div`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.primary};
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.title1};
`

const ThumbImage = styled(Image)`
  border-radius: 5px;
  width: 70px;
  height: 70px;
  object-fit: cover;
`

const RowTile = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
`

const ProductDesc = styled(RowTile)`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body5};
`

const Bold = styled.div`
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.bold};
`

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
    event: selectReturnActionEvent(state),
    detail: selectReturnDetail(state),
    detailEvent: selectReturnDetailEvent(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

export default connect(mapStateToProps)(ReturnDetail)
